export default __webpack_public_path__ + "static/media/work_design_icon-2.22962ab9.png";